// Schema.org JSON-LD builders used across pages.
// The site origin is provided by the platform environment variable.

const SITE_URL = (import.meta.env.VITE_SITE_URL || '') as string;

export const SITE_NAME = 'USFansLink';

export const SITE_DESCRIPTION =
  'USFansLink helps you explore the USFans spreadsheet, product links, seller information, reviews, shipping guides, QC tips and practical buying guides in one organized place.';

export const LOGO_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';

export const PUBLISHED_DATE = '2026-08-20';

export interface FaqItem {
  question: string;
  answer: string;
}

export function buildOrganizationSchema(): Record<string, unknown> {
  return {
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: LOGO_URL,
  };
}

export function buildWebSiteSchema(): Record<string, unknown> {
  return {
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESCRIPTION,
    inLanguage: ['en', 'pl', 'es', 'fr'],
  };
}

export function buildFaqSchema(items: FaqItem[]): Record<string, unknown> {
  return {
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}

export function buildArticleSchema(params: {
  path: string;
  headline: string;
  description: string;
  image?: string;
  language: string;
}): Record<string, unknown> {
  const url = params.path === '/' ? SITE_URL : `${SITE_URL}${params.path}`;
  return {
    '@type': 'Article',
    headline: params.headline,
    description: params.description,
    ...(params.image ? { image: params.image } : {}),
    author: {
      '@type': 'Organization',
      name: 'USFansLink Editorial Team',
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: {
        '@type': 'ImageObject',
        url: LOGO_URL,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    datePublished: PUBLISHED_DATE,
    dateModified: PUBLISHED_DATE,
    inLanguage: params.language,
  };
}